import { useQuery } from '@tanstack/react-query';
import { globalSearch, getRecentlyViewed } from '../api/globalSearch';
import { GlobalSearchApiResponse } from 'types/globalSearch';
import { QUERY_KEYS } from 'service/querykeys';

/**
 * Fetches grouped search results from the global search endpoint.
 * Only fires when `query` is non-empty.
 */
export const useGlobalSearchQuery = (query: string, projectUuid?: string) => {
  return useQuery<GlobalSearchApiResponse>({
    queryKey: QUERY_KEYS.GLOBAL_SEARCH(query, projectUuid),
    queryFn: () => globalSearch(query, projectUuid),
    enabled: query.trim().length > 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};

/**
 * Fetches the last 7 recently viewed work items.
 * Enabled when the search input is focused and empty.
 */
export const useRecentlyViewedQuery = (enabled: boolean, projectUuid?: string) => {
  return useQuery<GlobalSearchApiResponse>({
    queryKey: QUERY_KEYS.RECENTLY_VIEWED(projectUuid),
    queryFn: () => getRecentlyViewed(projectUuid),
    enabled,
    staleTime: 0, // always refetch so the list is up-to-date each time the overlay opens
    refetchOnWindowFocus: false,
  });
};
